<template>
  <main v-if="post" class="section article-page">
    <div class="page-shell">
      <header class="page-head">
        <h1>{{ post.title }}</h1>
        <p class="meta-row">{{ post.date }}</p>
      </header>

      <img class="cover" :src="post.cover" :alt="post.title" />

      <article class="body card panel">
        <RichContentRenderer :sections="post.sections" />
      </article>
    </div>
  </main>

  <NotFoundView v-else />
</template>

<script>
import { blogPosts } from '@/data/content';
import RichContentRenderer from '@/components/RichContentRenderer.vue';
import NotFoundView from '@/views/NotFoundView.vue';

export default {
  components: { RichContentRenderer, NotFoundView },
  computed: {
    post() {
      return blogPosts.find((entry) => entry.slug === this.$route.params.slug);
    },
  },
};
</script>

<style scoped>
.article-page {
  padding-top: clamp(10rem, 15vw, 12rem);
}

.cover {
  width: 100%;
  max-height: 520px;
  object-fit: cover;
  border-radius: var(--radius);
  border: 1px solid var(--line);
}

.body {
  margin-top: 1rem;
}
</style>
